import { render, staticRenderFns } from "./TheTags.vue?vue&type=template&id=6c6befa2&"
import script from "./TheTags.vue?vue&type=script&lang=js&"
export * from "./TheTags.vue?vue&type=script&lang=js&"
import style0 from "./TheTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports